import { render, staticRenderFns } from "./address-selector.vue?vue&type=template&id=5a93f920"
import script from "./address-selector.vue?vue&type=script&lang=js"
export * from "./address-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports